import { makeAutoObservable, action, observable } from 'mobx';
import { getShareInfo } from '@service/share';
import { getJobList } from '@service/social';
import { formatSearchQuery } from '@utils/formatSearchEum';
import { Toast } from '@ss/mtd-react-mobile';
import { urlParse } from '@block/utils';
import JobCommonStore from './jobCommon';

class SharePositionList {
  @observable jobList: any = null;

  @observable pageInfo = {
    pageSize: 10,
    pageNo: 0,
  };

  @observable keyword = '';

  @observable isInit = true;

  @observable shareInfo: {
    jobId?: [];
    isEffective?: boolean;
  } = {};

  @observable isInitData = true;

  // 列表是否有更多
  @observable hasMore = true;

  @observable loading = false;

  @observable queryInfo = {};

  // 当前选择的分享id
  @observable selectShareIds: Array<string> = [];

  // 是否分享全部
  @observable isShareAll = false;

  JobCommonStore;

  @observable shareParams: {
    token?: '';
    jobShareType?: '';
    jobUnionIds?: [];
  } = {};

  constructor() {
    this.JobCommonStore = JobCommonStore;
    makeAutoObservable(this);
  }

  initData = async (params, go) => {
    const { staffSsoId, jobShareType = '1', token } = params;
    const newParams = {
      jobShareType,
      staffSsoId,
      token,
    };
    let { shareInfo } = this;
    if (this?.isInit) {
      shareInfo = await getShareInfo(newParams);
    }
    // token失效跳转到首页
    if (!shareInfo?.isEffective) {
      Toast.show({
        content: '该链接已失效，即将跳转到美团招聘官网首页',
        duration: 3000,
      });
      setTimeout(() => {
        go('/home', { replace: true });
      }, 2000);
    } else {
      this.setShareParams({
        jobShareType,
        jobUnionIds: shareInfo?.jobId || [],
      });
      this.setShareInfo(shareInfo);
      this.fetchData();
    }
  };

  loadMore = async () => {
    if (this.isInit) {
      return;
    }
    if (this.loading) {
      return;
    }
    this.setLoading(true);
    const currentQueryInfo = {
      ...this.shareParams,
      ...urlParse(window.location.search),
    };
    const res = await getJobList({
      page: {
        pageSize: this?.pageInfo?.pageSize,
        pageNo: this.pageInfo.pageNo + 1,
      },
      ...formatSearchQuery(currentQueryInfo),
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { list, page } = res;
    const currentList = list && list?.length > 0 ? [...this.jobList, ...list] : this.jobList;
    this.setPageInfo({
      ...page,
      pageNo: this.pageInfo.pageNo + 1,
    });
    this.setJobList(currentList);
    if (page?.totalCount <= currentList?.length || list.length < page?.pageSize) {
      this.setHasMore(false);
    }
    this.setLoading(false);
  };

  @action
  setIsInit = (init) => {
    this.isInit = init;
  };

  @action
  setKeyword = (value) => {
    this.keyword = value;
  };

  @action
  setHasMore = (hasMore) => {
    this.hasMore = hasMore;
  };

  @action
  setShareInfo = (shareInfo) => {
    this.shareInfo = shareInfo;
  };

  // 搜索数据
  @action
  fetchData = async () => {
    if (!this.loading) {
      this.setLoading(true);
      this.setHasMore(false);
      const params = urlParse(window.location.search);
      const currentParams = {
        ...params,
      };
      // 获取筛选的信息
      let formatQuery = formatSearchQuery(currentParams);
      // @ts-ignore
      formatQuery = {
        ...formatQuery,
        ...this?.shareParams,
      };
      const res = await getJobList({
        page: {
          pageSize: this?.pageInfo?.pageSize,
          pageNo: 1,
        },
        ...formatQuery,
      });
      const { list, page } = res;
      this.setJobList(list);
      this.setLoading(false);
      this.setPageInfo({
        ...page,
        pageNo: 1,
      });
      if (page?.totalCount === 0 || page?.totalCount <= list?.length) {
        this.setHasMore(false);
      } else {
        this.setHasMore(true);
      }
    }
    this.setLoading(false);
    this.isInit = false;
    return null;
  };

  @action
  setIsShareAll = (value) => {
    this.isShareAll = value;
    if (!value) {
      this.selectShareIds = [];
    } else {
      if (!this?.jobList.length) {
        this.selectShareIds = [];
      }
      // @ts-ignore
      this.selectShareIds = this?.jobList?.map((item: any) => {
        if (!item || !item?.jobUnionId) return '';
        return item.jobUnionId;
      });
    }
  };

  @action
  setJobList = (data) => {
    this.jobList = data;
  };

  @action
  setPageInfo = (page) => {
    this.pageInfo = page;
  };

  @action
  setQueryInfo = (query) => {
    this.queryInfo = {
      ...query,
    };
  };

  @action
  setShareParams = (shareParams) => {
    this.shareParams = shareParams;
  };

  @action
  setLoading = (isLoading) => {
    this.loading = isLoading;
  };

  @action
  setSelectShareIds = (ids) => {
    this.selectShareIds = ids;
  };
}

const SharePositionStore = new SharePositionList();

export default SharePositionStore;
